module.exports = __webpack_public_path__ + "media/application/images/instagram-black-fb6bf9e6f9094d4b840ddecc3d980846.svg";